import { Market, MarketDetails } from '../types';

function orderPricesByQuarter(prices: any) {

  const ordered = [...prices].sort((a, b) => {
    const [yearA, quarterA] = a.quarter.split('Q').map(Number);
    const [yearB, quarterB] = b.quarter.split('Q').map(Number);

    return yearA === yearB ? quarterA - quarterB : yearA - yearB;
  });

  return ordered
}

export function marketTransformer(market: Market): MarketDetails {

  return {
    id: market.id,
    status: market.status,
    createdAt: new Date(market.date_created).toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }),
    updatedAt: new Date(market.date_updated).toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }),
    title: market.title,
    description: market.description,
    prices: orderPricesByQuarter(market.prices),
    location: market.location.code,
    technology: market.technology?.code ?? 'unknown',
    dataSource: market.data_source,
    priceTrend: market.price_trend,
    interestTrend: market.interest_trend,
    chartTitle: market.chart_title,
    descriptionComments: market.description_comments,
    interval: market?.interval,
    minYAxis: market?.min_y_axis,
    maxYAxis: market?.max_y_axis,
  };
}
